import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-pv.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-pv.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { CreateApplicationDetailsPvConstants } from "./create-application-details-pv.constants";
import { DatePipe } from "@angular/common";
import { take, takeUntil } from "rxjs/operators";
import { SimulationUtils } from "../../../../../shared/utils/simulation-utils";
import { AppConfig } from "../../../../../app.config";
let CreateApplicationDetailsPvComponent = class CreateApplicationDetailsPvComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    appController;
    appConfig;
    changeDetectorRefs;
    datePipe;
    detailsForm;
    validationMessages = CreateApplicationDetailsPvConstants.VALIDATION_MESSAGES;
    valuationRollSelectLabel = CreateApplicationDetailsPvConstants.VALUATION_ROLL_SELECT_LABEL;
    valuationRollSelectFormControlName = CreateApplicationDetailsPvConstants.VALUATION_ROLL_SELECT_FORM_CONTROL_NAME;
    descriptionLabel = CreateApplicationDetailsPvConstants.DESCRIPTION_LABEL;
    descriptionFormControlName = CreateApplicationDetailsPvConstants.DESCRIPTION_FORM_CONTROL_NAME;
    valuationMethodSelectLabel = CreateApplicationDetailsPvConstants.VALUATIONBLOCK_METHOD_SELECT_LABEL;
    valuationMethodSelectFormControlName = CreateApplicationDetailsPvConstants.VALUATIONBLOCK_METHOD_SELECT_FORM_CONTROL_NAME;
    valuationSplitMethodFormArrayControlName = CreateApplicationDetailsPvConstants.VALUATION_BLOCK_SPLIT_METHOD_FORM_NAME;
    valuationSplitMethodFormControlName = CreateApplicationDetailsPvConstants.VALUATION_BLOCK_SPLIT_METHOD_FORM_CONTROL_NAME;
    propertyTypeSelectLabel = CreateApplicationDetailsPvConstants.PROPERTY_TYPE_SELECT_LABEL;
    propertyTypeSelectFormControlName = CreateApplicationDetailsPvConstants.PROPERTY_TYPE_SELECT_FORM_CONTROL_NAME;
    valReasonLabel = CreateApplicationDetailsPvConstants.VALUATION_REASON_LABEL;
    valReasonFormControlName = CreateApplicationDetailsPvConstants.VALUATION_REASON_FORM_CONTROL_NAME;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    addValuationMethodTypeLabel = "Add valuation method";
    lookupsSubscription;
    valuationRollOptions = [];
    valuationMethodOptions = [];
    valuationMethodSplitOptions = [];
    valuationReasonOptions = [];
    propertyTypesOptions = [];
    propertyTypeCodes = [];
    selectedSplitMethods = [];
    availableMethodSplitOptions = [];
    valuationMethodSplitOptionArray = [];
    methodAliases = [];
    constructor(createApplicationService, aflaModuleStrategyService, appController, appConfig, changeDetectorRefs, datePipe) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.appConfig = appConfig;
        this.changeDetectorRefs = changeDetectorRefs;
        this.datePipe = datePipe;
    }
    // Init form
    ngOnInit() {
        if (this.appController.moduleSimulateMode) {
            const defaults = SimulationUtils.simulate_Create_Application();
            this.propertyTypeCodes = defaults.propertyTypeCodes;
            this.propertyTypesOptions = defaults.propertyTypesOptions;
            this.valuationMethodOptions = defaults.valuationMethodOptions;
            this.valuationMethodSplitOptions = defaults.valuationMethodSplitOptions;
            this.valuationReasonOptions = defaults.valuationReasonOptions;
            this.valuationRollOptions = defaults.valuationRollOptions;
            this.valuationRollOptions.forEach(item => {
                item.moduleId = this.createApplicationService.moduleID;
                item.projectCycle.moduleId = this.createApplicationService.moduleID;
            });
        }
        else {
            if (this.aflaModuleStrategyService.lookups.has("valuationMethodSplitTypes")) {
                this.valuationMethodSplitOptions =
                    this.aflaModuleStrategyService.lookups.get("valuationMethodSplitTypes");
                this.propertyTypesOptions =
                    this.aflaModuleStrategyService.lookups.get("propertyTypes");
                this.propertyTypeCodes =
                    this.aflaModuleStrategyService.lookups.get("propertyCodes");
                this.valuationReasonOptions = this.aflaModuleStrategyService.lookups.get("valuationReasons");
                this.valuationMethodOptions = this.aflaModuleStrategyService.lookups.get("valuationMethodTypes");
            }
            else {
                this.getLookups();
            }
            this.getMetadata();
        }
        this.initForm();
        this.getValuationRolls();
        this.aflaModuleStrategyService.populateValuationMethods();
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("detailsForm");
        this.detailsForm = form;
        const valuationMethodControl = this.getSplitValuationMethodTypes();
        this.selectedSplitMethods = [];
        if (this.checkValuationMethodsValidity(valuationMethodControl)) {
            for (const formControl of valuationMethodControl.controls) {
                const method = formControl.get("valuationSplitMethodControlName").value;
                this.selectedSplitMethods.push(method);
                if (this.selectedSplitMethods.length <
                    this.valuationMethodSplitOptions.length) {
                    const availableMethods = this.getAvailableMethods();
                    availableMethods.push(method);
                    availableMethods.sort((a, b) => a.value?.localeCompare(b?.value));
                    this.availableMethodSplitOptions = availableMethods;
                    this.valuationMethodSplitOptionArray.push(availableMethods);
                }
            }
        }
        this.changeDetectorRefs.markForCheck();
        this.changeDetectorRefs.detectChanges();
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    loadMetadata(stepMeta) { }
    getValuationRolls() {
        if (this.appController.moduleSimulateMode) {
            const defaults = SimulationUtils.simulate_Create_Application();
            this.valuationRollOptions = defaults.valuationRollOptions;
            this.valuationRollOptions.forEach(item => {
                item.moduleId = this.createApplicationService.moduleID;
                item.projectCycle.moduleId = this.createApplicationService.moduleID;
            });
            this.changeDetectorRefs.markForCheck();
        }
        else {
            const dateString = this.datePipe.transform(new Date(), "yyyy-MM-dd") + "T00:00:00Z";
            const params = {
                $expand: "projectCycle,parentValuationRoll",
                $filter: `moduleId eq ${this.appController.selectedModuleID} and completed eq false and toDate ge ${dateString}`,
            };
            this.createApplicationService
                .getValuationRolls(params)
                .pipe(takeUntil(this._destroy$), take(1))
                .subscribe({
                next: (rolls) => {
                    this.valuationRollOptions = rolls.value.sort((a, b) => a.projectCycle.name?.localeCompare(b?.projectCycle.name) ||
                        a.type?.localeCompare(b?.type)); // 0 - (a.projectCycle.name.toLowerCase() > b.projectCycle.name.toLowerCase() ? -1 : 1) || 0 - (b.type.toLowerCase() > a.type.toLowerCase() ? -1 : 1));
                    this.changeDetectorRefs.markForCheck();
                },
                error: (error) => {
                    this.appController.handleServerErrorMessage(CreateApplicationDetailsPvConstants.STEP_TITLE, error, CRUDOperation.Get);
                },
            });
        }
    }
    getLookups() {
        const lookupParams = {
            $filter: `moduleId eq ${this.createApplicationService.moduleID}  and (name eq 'PropertyType' or name eq 'ValuationMethod' or name eq 'ValuationReason')`,
        };
        this.lookupsSubscription = this.createApplicationService
            .getLookupsObservable(lookupParams)
            .subscribe({
            next: (response) => {
                this.onGetLookupsCompleted(response);
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(CreateApplicationDetailsPvConstants.STEP_TITLE, error, CRUDOperation.Get);
            },
        });
    }
    onGetLookupsCompleted(response) {
        const propertyTypeCodes = [];
        const propertyTypes = [];
        const valuationMethodTypes = [];
        const valuationMethodSplitTypes = [];
        const valuationReasons = [];
        if (response && response.value.length > 0) {
            response.value.forEach((item) => {
                if (item.name === "PropertyType") {
                    propertyTypeCodes.push(JSON.parse(item.content).code);
                    propertyTypes.push(JSON.parse(item.content));
                }
                if (item.name === "ValuationMethod") {
                    valuationMethodTypes.push(JSON.parse(item.content));
                    const i = JSON.parse(item.content);
                    if (i.value !== "Hybrid - split" && i.value !== "Hybrid - mixed") {
                        valuationMethodSplitTypes.push(i);
                    }
                }
                if (item.name === "ValuationReason") {
                    valuationReasons.push(JSON.parse(item.content));
                }
            });
        }
        const methodAliases = AppConfig.settings.propertyValuation.methodAliases;
        valuationMethodTypes.forEach((x) => {
            for (const [key, value] of Object.entries(methodAliases)) {
                if (key === x.value) {
                    x.value = value;
                }
            }
        });
        this.valuationMethodOptions.sort((a, b) => a.value.localeCompare(b.value));
        this.valuationMethodSplitOptions.sort((a, b) => a.value.localeCompare(b.value));
        this.propertyTypesOptions.sort((a, b) => a.code.localeCompare(b.code));
        this.propertyTypeCodes = [...new Set(propertyTypeCodes)];
        this.propertyTypeCodes.sort();
        this.aflaModuleStrategyService.lookups.set("propertyCodes", this.propertyTypeCodes);
        this.aflaModuleStrategyService.lookups.set("propertyTypes", propertyTypes);
        this.propertyTypesOptions = propertyTypes;
        this.propertyTypesOptions.sort((a, b) => a.code?.localeCompare(b?.code));
        this.aflaModuleStrategyService.lookups.set("valuationMethodTypes", valuationMethodTypes);
        this.valuationMethodOptions = valuationMethodTypes;
        this.valuationMethodOptions.sort((a, b) => a.value?.localeCompare(b?.value));
        this.aflaModuleStrategyService.lookups.set("valuationMethodSplitTypes", valuationMethodSplitTypes);
        this.valuationMethodSplitOptions = valuationMethodSplitTypes;
        this.valuationMethodSplitOptions.sort((a, b) => a.value?.localeCompare(b?.value));
        this.valuationReasonOptions = valuationReasons;
        this.aflaModuleStrategyService.lookups.set("valuationReasons", valuationReasons);
        this.changeDetectorRefs.markForCheck();
        this.changeDetectorRefs.detectChanges();
    }
    valuationMethodChanged($event) {
        this.detailsForm
            .get(this.valuationMethodSelectFormControlName)
            .markAllAsTouched();
        if (this.detailsForm.get(this.valuationMethodSelectFormControlName).value
            ?.value === "Hybrid - mixed" ||
            this.detailsForm.get(this.valuationMethodSelectFormControlName).value
                ?.value === "Hybrid - split") {
            const splits = this.getSplitValuationMethodTypes();
            if (splits.length === 0) {
                this.onBtnAddValuationMethodClicked();
            }
            this.detailsForm.get(this.valuationSplitMethodFormControlName);
        }
        this.updateValidationRules();
    }
    updateValidationRules() {
        const valuationMethod = this.detailsForm.get(this.valuationMethodSelectFormControlName).value?.value;
        const splitValuationArray = this.getSplitValuationMethodTypes();
        if (valuationMethod && valuationMethod.indexOf("Hybrid") > -1) {
            splitValuationArray.addValidators([Validators.minLength(2)]);
            splitValuationArray.updateValueAndValidity();
        }
        else if (splitValuationArray) {
            splitValuationArray.clearValidators();
            splitValuationArray.updateValueAndValidity();
        }
    }
    getSplitValuationMethodTypes() {
        return this.detailsForm.get(this.valuationSplitMethodFormArrayControlName);
    }
    onBtnRemoveValuationMethodClicked(i) {
        const controls = this.getSplitValuationMethodTypes();
        if (controls.controls.length > 0) {
            controls.removeAt(i);
            const removedOption = this.valuationMethodSplitOptionArray.splice(i, i);
            this.updateOptionListsAfterRemove();
        }
    }
    updateOptionListsAfterChange(i) {
        const methodControls = this.getSplitValuationMethodTypes();
        const newMethod = methodControls.controls[i].get("valuationSplitMethodControlName").value;
        if (i !== methodControls.controls.length - 1) {
            for (let j = 0; j < methodControls.controls.length; j++) {
                if (i !== j) {
                    if (newMethod ===
                        methodControls.controls[j].get("valuationSplitMethodControlName")
                            .value) {
                        this.onBtnRemoveValuationMethodClicked(j);
                    }
                }
            }
        }
    }
    updateOptionListsAfterRemove() {
        this.selectedSplitMethods = this.getMethods(this.getSplitValuationMethodTypes());
        const availableMethods = this.getAvailableMethods();
        this.availableMethodSplitOptions = availableMethods;
        this.valuationMethodSplitOptionArray.forEach((optionList) => {
            availableMethods.forEach((method) => {
                if (optionList.indexOf(method) < 0) {
                    optionList.push(method);
                }
            });
        });
    }
    checkValuationMethodsValidity(methodsControl) {
        if (methodsControl.controls.length === 0) {
            return true;
        }
        else {
            try {
                methodsControl.controls.forEach((ctrl) => {
                    if (!ctrl.valid) {
                        throw new Error("Invalid method value");
                    }
                });
                return true;
            }
            catch (e) {
                return false;
            }
        }
    }
    onBtnAddValuationMethodClicked() {
        // TODO:: Check what valuation methods have alrady been selected and create an option array of remaining methods
        const valuationMethodControl = this.getSplitValuationMethodTypes();
        if (this.checkValuationMethodsValidity(valuationMethodControl)) {
            this.selectedSplitMethods = this.getMethods(valuationMethodControl);
            if (this.selectedSplitMethods.length <
                this.valuationMethodSplitOptions.length) {
                const availableMethods = this.getAvailableMethods();
                this.availableMethodSplitOptions = availableMethods;
                this.valuationMethodSplitOptionArray.push(availableMethods);
                const typeGroup = new FormGroup({
                    valuationSplitMethodControlName: new FormControl(null, [
                        Validators.required,
                    ]),
                });
                valuationMethodControl.push(typeGroup);
            }
            else {
                // TODO:: show message that the max number of methods has been reached
            }
        }
        else {
            valuationMethodControl.controls.forEach((ctrl) => {
                ctrl.markAllAsTouched();
            });
        }
    }
    getAvailableMethods() {
        function getDifference(a, b) {
            return a.filter((element) => {
                return !b.includes(element);
            });
        }
        const availableMethods = [
            ...getDifference(this.selectedSplitMethods, this.valuationMethodSplitOptions),
            ...getDifference(this.valuationMethodSplitOptions, this.selectedSplitMethods),
        ];
        return availableMethods;
    }
    getMethods(methodsForm) {
        const methods = [];
        for (const formControl of methodsForm.controls) {
            const method = formControl.get("valuationSplitMethodControlName").value;
            if (method) {
                methods.push(method);
            }
        }
        return methods;
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: AppConfig },
        { type: ChangeDetectorRef },
        { type: DatePipe }
    ];
};
CreateApplicationDetailsPvComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-create-application-details-pv",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsPvComponent);
export { CreateApplicationDetailsPvComponent };
